// import {chunk as _chunk} from 'lodash'
import Chart from 'chart.js'
import {Line} from 'vue-chartjs'

const draw = Chart.controllers.line.prototype.draw
Chart.controllers.line = Chart.controllers.line.extend({
  draw: function () {
    draw.apply(this, arguments)

    if (this.chart.tooltip._active && this.chart.tooltip._active.length && this.chart.scales['y-axis-0']) {
      const activePoint = this.chart.tooltip._active[0],
        ctx = this.chart.ctx,
        x = activePoint.tooltipPosition().x,
        topY = this.chart.scales['y-axis-0'].top,
        bottomY = this.chart.scales['y-axis-0'].bottom

      // draw line
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(x, topY)
      ctx.lineTo(x, bottomY)
      ctx.lineWidth = 1
      ctx.strokeStyle = '#ccccd6'
      ctx.stroke()
      ctx.restore()
    }
  }
})

export default {
  name: 'crawl_line_chart',

  extends: Line,

  props: {
    volume_data: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      chart_data: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          titleFontSize: 12,
          bodyFontSize: 12,
          enabled: true,
          mode: 'label',
          intersect: false,
          axis: 'x',
          callbacks: {
            title: function (tooltipItems) {
              if (tooltipItems[0] && tooltipItems[0].xLabel) {
                return tooltipItems[0].xLabel
                  .replace(/^.+\(/, '')
                  .replace(/[()]/ig, '')
              } else {
                return ''
              }
            },
            label: function (tooltipItems, data) {
              const value = tooltipItems.yLabel % 1 === 0
                ? tooltipItems.yLabel.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
                : tooltipItems.yLabel.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + value
            }
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                maxTicksLimit: 8,
                stepSize: 1,
                maxRotation: 0,
                minRotation: 0,
                align: 'start',
              }
            }
          ],
          yAxes: [
            {
              position: 'left',
              display: true,
              ticks: {
                display: true,
                beginAtZero: true,
                maxTicksLimit: 7,
                callback: function (value) {
                  return value.toLocaleString();
                }
              },
              gridLines: {
                display: true,
                borderDash: [8, 4],
                color: 'rgb(229,229,229)'
              }
            }
          ]
        },
        hover: {
          mode: 'nearest',
          intersect: false,
          axis: 'xy'
        }
      }
    }
  },

  mounted() {
    this.m__render_chart()
  },

  watch: {
    volume_data: function () {
      this.m__render_chart()
    }
  },

  methods: {
    m__render_chart() {
      // todo: v1
      // const year_grouped = new Map()
      // for (const item of this.volume_data) {
      //   const year = this.dayjs(new Date(item.createdAt)).year()
      //   if (!year_grouped.has(year)) year_grouped.set(year, [])
      //   year_grouped.get(year).push(this.dayjs(new Date(item.createdAt)).unix())
      // }
      //
      // const earliest_date = new Map()
      // for (const [year, dates] of year_grouped) {
      //   earliest_date.set(year, Math.min(...dates))
      // }
      //
      // this.chart_data.labels = this.volume_data.map(i => {
      //   const date = this.dayjs(new Date(i.createdAt))
      //   if (earliest_date.get(date.year()) === date.unix()) {
      //     return this.dayjs(new Date(i.createdAt)).format('DD/MM/YYYY')
      //   } else {
      //     return this.dayjs(new Date(i.createdAt)).format('DD/MM')
      //   }
      // })

      try {
        // todo: v2
        // const data_chunk = _chunk(this.volume_data, Math.ceil(this.volume_data.length / this.options.scales.xAxes[0].ticks.maxTicksLimit))
        // // console.log(data_chunk)
        //
        // const year_grouped = new Map()
        // for (const chunk of data_chunk) {
        //   if (chunk.length) {
        //     const year = this.dayjs(new Date(chunk[0].createdAt)).year()
        //     if (!year_grouped.has(year)) year_grouped.set(year, [])
        //     year_grouped.get(year).push(this.dayjs(new Date(chunk[0].createdAt)).unix())
        //   }
        // }
        // // console.log('year_grouped', year_grouped)
        //
        // const earliest_date = new Map()
        // for (const [year, dates] of year_grouped) {
        //   earliest_date.set(year, Math.min(...dates))
        // }
        // // console.log('earliest_date', earliest_date)
        //
        // this.chart_data.labels = this.volume_data.map(i => {
        //   const date = this.dayjs(new Date(i.createdAt))
        //   if (earliest_date.get(date.year()) === date.unix()) {
        //     return this.dayjs(new Date(i.createdAt)).format('DD/MM/YYYY')
        //   } else {
        //     return this.dayjs(new Date(i.createdAt)).format('DD/MM')
        //   }
        // })

        this.chart_data.labels = this.volume_data.map(i => {
          return this.dayjs(new Date(i.createdAt)).format('DD/MM/YYYY')
        })
      } catch (e) {
        console.error(e)

        // todo: old
        this.chart_data.labels = this.volume_data.map(i => {
          return this.dayjs(new Date(i.createdAt)).format('DD/MM')
        })
      }

      this.chart_data.datasets = [
        {
          label: this.$t('base.volume'),
          data: this.volume_data.map(i => Math.round(i.volume)),
          point: '0',
          type: 'line',
          pointBorderWith: 0,
          lineTension: 0,
          showLines: true,
          backgroundColor: 'transparent',
          pointHoverBorderColor: 'transparent',
          pointHoverBorderWidth: 0,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          pointHoverBackgroundColor: 'transparent',
          borderColor: 'rgb(54, 127, 227)'
        }
      ]

      this.renderChart(this.chart_data, this.options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tool/crawl_line_chartjs.js